const styles = (theme) => ({
  container: {
    width: "100%",

  }
});

export default styles;
